<template>
<div class="pagewide panel mtpage landingpage">

    <maincontent>
        <template v-slot:content>
            <div class="wrapper">

             


                <template v-if="locale == 'ru'">

                    <div class="slide slide1">
                        <div class="slideWrapper">
                            <div class="caption">
                                <span>📲 Скачать Snippity для Android (.APK)</span>
                            </div>
                            <div class="subcaption">
                                <span> Snippity — это доброе приложение с короткими новостными историями для детей от 3 до 7 лет. Здесь малыши узнают, что происходит в мире: в спорте, искусстве, науке и природе — всё рассказано простыми словами, в виде красочных слайдов с голосом и музыкой.</span>
                            </div>

                            <button class="button orange" @click="download">
                                {{$t('common.2901046')}}
                            </button>
                        </div>
                    </div>

                    <div class="slide slide3">
                        <div class="slideWrapper">
                            <div class="caption">
                                <span>✅ Почему стоит скачать прямо сейчас?</span>
                            </div>
                            <div class="list">
                                <ul>
                                    <li>🧒 Истории, созданные для малышей — коротко, понятно, без перегрузки.</li>
                                    <li>🎨 Яркие картинки и уютный голос рассказчика.</li>
                                    <li>📵 Без рекламы, безопасно для детского пользования.</li>
                                    <li>👨‍👩‍👧 Подходит для семейного просмотра.</li>
                                </ul>
                            </div>
                        </div>
                    </div>


                    <div class="slide slide4">
                        <div class="slideWrapper">
                            <div class="caption">
                                <span>⚠️ Установка APK</span>
                            </div>
                            <div class="list">
                                <ul>
                                    <li>Скачайте файл на устройство.</li>
                                    <li>Разрешите установку из неизвестных источников в настройках Android.</li>
                                    <li>Откройте файл и нажмите «Установить».</li>
                                    <li>Не переживайте — наш файл безопасен и проверен. Мы не собираем личные данные и не показываем рекламу.</li>
                                </ul>
                            </div>
                        </div>
                    </div>


                </template>

                <template v-if="locale == 'en'">
                    <div class="slide slide1">
                    <div class="slideWrapper">
                    <div class="caption">
                    <span>📲 Download Snippity for Android (.APK)</span>
                    </div>
                    <div class="subcaption">
                    <span> Snippity is a kind app with short news stories for children aged 3 to 7. Here kids learn what's happening in the world: in sports, art, science and nature - everything is told in simple words, in the form of colorful slides with voice and music.</span>
                    </div>

                    <button class="button orange" @click="download">
                    {{$t('common.2901046')}}
                    </button>
                    </div>
                    </div>

                    <div class="slide slide3">
                    <div class="slideWrapper">
                    <div class="caption">
                    <span>✅ Why is it worth downloading right now?</span>
                    </div>
                    <div class="list">
                    <ul>
                    <li>🧒 Stories created for kids - short, clear, without overload.</li>
                    <li>🎨 Bright pictures and a cozy voice of the narrator.</li>
                    <li>📵 No ads, safe for children to use.</li>
                    <li>👨‍👩‍👧 Family-friendly.</li>
                    </ul>
                    </div>
                    </div>
                    </div>

                    <div class="slide slide4">
                    <div class="slideWrapper">
                    <div class="caption">
                    <span>⚠️ Install APK</span>
                    </div>
                    <div class="list">
                    <ul>
                    <li>Download the file to your device.</li>
                    <li>Allow installation from unknown sources in Android settings.</li>
                    <li>Open the file and click "Install".</li>
                    <li>Don't worry - our file is safe and verified. We do not collect personal data and do not show ads.</li>
                    </ul>
                    </div>
                    </div>
                    </div>
                </template>

                

                <div class="buttonWrapper">
                    <button class="button orange" @click="download">
                        {{$t('common.2901046')}}
                    </button>
                </div>

                <div class="brandWrapper">
                    <logotype :big="true"/>
                </div>

                <div class="footerWrapper">
                    <footerComponent />
                </div>
            </div>
        </template>
    </maincontent>

</div>
</template>

<style scoped lang="sass">
.slide1
    background: #fdfdd0
    color : #000

.slide2
    border-bottom: $r solid #fdfdd0

.slide3
    border-bottom: $r solid #dc0050

.buttonWrapper
    text-align: center
    margin : 10 * $r auto




.stikerWrapper
    margin-top: 4 * $r
    text-align: center
    img
        border-radius: 12px

</style>

<script>

import { mapState } from 'vuex';


export default {
    name: 'applications_page',
    components: {
        
    },

    methods: {
        download : function(){

            this.$store.commit('globalpreloader', true)

            this.core.api.autoupdater.getLatest().then((r = {}) => {
                var assets = r.assets|| [];

                this.$store.commit('globalpreloader', false)

                var l = _.find(assets, function(a){
                    return a.name == 'snippity.apk'
                })

                if (l){

                    var link = document.createElement('a');
                        link.setAttribute('href', l.browser_download_url);
                        link.setAttribute('download','download');
                        link.click();

                    setTimeout(() => {
                        link.remove()
                    }, 1000)
                }
                
                else{
                    this.$store.commit('icon', {
                        icon: 'error',
                        message: this.$t("errors.general")
                    })
                }

            })
        }
    },

    data : function(){
		return { 
			searchEnabled : false,
            locales : {en : true, ru : true}

		}
	},

	computed: mapState({
        locale : function(state){
            return this.locales[state.locale] ? state.locale : 'en'
        }
	}),

    mounted() {

    }
}
</script>
